import React from 'react';
import { motion } from 'framer-motion';
import '../styles/skills.css';



const skills = [
  {
    short: 'SAP / Ivalua Expert',
    full: 'Proficient in procurement softwares such as SAP HANA/ECC, Ivalua and skilled in data analysis and reporting.'
  },
  {
    short: 'Strong Communicator',
    full: 'Excellent communication, negotiation, and interpersonal skills, with proven ability to build relationship and collaborate effectively.'
  },
  {
    short: 'Team Leadership',
    full: 'Experienced in leading cross functional teams and fostering collaborative work environment.'
  },
  {
    short: 'Strategic Sourcing',
    full: 'Developing and implementing strategies for sourcing goods and services is a core function. '
  },
  {
    short: 'Risk Management',
    full: 'Identifying, assessing, and mitigating potential risks in the procurement process is vital.'
  },
  {
    short: 'Financial Acumen',
    full: 'Experienced in leading cross functional teams and fostering collaborative work environment.'
  },
  {
    short: 'Eager Contributor',
    full: 'Understanding financial concepts like budgeting, cost analysis, and return on investment is important.'
  }
];

const Skill = () => {
  return (
    <section className="skill-section">
      <h2 className="skill-heading">My Skills</h2>
      <div className="skill-underline"></div>

      <div className="skill-grid">
        {skills.map((skill, index) => (
          <motion.div
            className="skill-card"
            key={index}
            initial={{ y: 100, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: index * 0.1 }}
            viewport={{ once: true }}
          >
            <div className="card-inner">
              <div className="card-front">
                <p>{skill.short}</p>
              </div>
              <div className="card-back">
                <p>{skill.full}</p>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
      <span className="interaction-hint">
  <span className="desktop-only">Hover to interact</span>
  <span className="mobile-only">Tap to interact</span>
</span>

    </section>
  );
};

export default Skill;
